import { useState, useEffect } from 'react';

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <a
      href="https://wa.me/5516992188698?text=Ol%C3%A1%21+Vim+pelo+site+da+TL+Artes+%26+M%C3%BAsica+e+gostaria+de+saber+mais+informa%C3%A7%C3%B5es+sobre+as+aulas."
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-[90] flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full pl-4 pr-5 py-3 shadow-lg hover:shadow-xl transition-all duration-500 cursor-pointer ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'
      }`}
      aria-label="Falar no WhatsApp"
    >
      <span className="relative">
        <i className="ri-whatsapp-line text-xl"></i>
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-white animate-ping"></span>
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-white"></span>
      </span>
      <span className="font-sans text-[13px] font-semibold tracking-wide whitespace-nowrap hidden sm:inline">
        Fale conosco
      </span>
    </a>
  );
}